<template>
  <v-dialog v-loading="loading" v-model="isVisible"  persistent
            max-width="90%">
    <v-form ref="form" v-if="item">
      <v-card>
        <v-card-title>
          <span class="title">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs6 md6>
              <v-text-field v-model="itemInfo.carId" :label="`大牌號碼`"
                            placeholder="輸入大牌號碼"></v-text-field>
            </v-flex>
            <v-flex xs6 md6>
              <v-text-field v-model="itemInfo.realPrice" :label="`實撥金額`"
                            placeholder="輸入實撥金額"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
          <v-flex xs12 lg12>
            <v-select
              :items="caseTypeList"
              :attach="true"
              item-text="text"
              item-value="key"
              v-model="busType"
              label="優撥相關文件"
              v-on:change="changeRoute"
            ></v-select>
            <!-- <select v-model="busType">
                <option v-for="caseTypeItem in caseTypeList" :key="caseTypeItem.key" :value="caseTypeItem.text">{{caseTypeItem.text}}</option>
          </select> -->
          </v-flex>
          </v-layout>

          <v-container v-if="isDropboxVisible">
            <v-layout row wrap>
                <v-flex xs12 md12>
                <div class="dropbox">
                    <input
                    type="file"
                    ref="file"
                    multiple
                    @change="filesChange($event.target.name, $event.target.files);"
                    accept="image/*, .pdf"
                    class="input-file"
                    />
                    <p>
                    將PDF拖到此處
                    <br />或點擊上傳
                    </p>
                </div>
                </v-flex>
            </v-layout>
          </v-container>

          <v-layout v-if="uploadedFiles.length > 0" row wrap>
            <v-flex xs12 md12>
              <v-card>
                <v-container fluid
                  grid-list-md
                >
                  <v-layout row wrap>
                    <v-flex
                      v-for="file in uploadedFiles"
                      :key="`${file.caseId}`"
                      v-bind="{ [`xs3`]: true }"
                    >
                      <v-card>
                        <v-card-actions>
                            <v-layout fill-height>
                              <v-flex xs12>
                                <span v-text="file.name"></span>
                              </v-flex>
                            </v-layout>
                          <v-spacer></v-spacer>
                          <v-btn icon @click="removeImage(file.caseId)">
                            <v-icon large color="red darken-2">delete</v-icon>
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="closeDialogView">取消</v-btn>
          <v-btn color="blue darken-1" flat @click="save">確定</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <alert-view :visible="messageDialog.visible"
                  :title="messageDialog.title"
                  :content="messageDialog.text"
                  @confirmEvent="messageDialog.confirm">
    </alert-view>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {exportPdf} from '../pages/utils/tool';
import download from 'downloadjs';
import UseCaseModel from '../models/UseCaseModel';
import PriorityModel from '../models/PriorityModel';
import PDF from 'pdfjs-dist';
import JSZip from 'jszip';
import AlertView from '../components/AlertView'

export default {
  name: "PriorityCreditView",
  props:{
      item:Object,
      visible: Boolean,
    },
  components: {AlertView},
  data() {
    return {
      uploadedFiles: [],
      loading:false,
      width: 100,
      pdfDoc: null,
      pages: 0,
      pdfNmae:'',
      imageEditor: {
          visible: false,
          imageItem: null,
          confirm:()=>{},
          cancel:()=>{},
      },
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        showCancel: false,
        confirm: () => {},
        cancel: () => {},
      },
      isDropboxVisible:true,
      isVisible:false,
      busType: "",
      itemInfo: new PriorityModel(),
    };
  },
  watch:{
      isVisible(value){
        if(!value)
        {
          this.$emit('closeEvent');
        }
      }
    },
  computed: {
    ...mapGetters(['getUserInfo']),
    formTitle() {
        return '優撥專案'
    },
    editedItem() {
      if(!this.item.Appropriation) {
        this.item.Appropriation = 0;
      }
      return this.item;
    },
    caseTypeList() {
      let typeList = [
        { key: "1", text: "請款文件" },	// 必填
        { key: "2", text: "設定書" }, // 必填
      ];
      if (this.uploadedFiles.length > 0) {
        this.uploadedFiles.forEach((element) => {
          const index = typeList
            .map(function (e) {
              return e.key;
            }).indexOf(element.code);

            if (index > -1) {
              typeList.splice(index, 1);
            }
        });
      }
      return typeList;
    },
  },
  created() {
    this.isVisible = this.visible;
    this.itemInfo.agentId = this.getUserInfo.agentId;
    this.itemInfo.caseId = this.item.caseId;
    this.itemInfo.name = this.item.name;
    this.itemInfo.memberId = this.item.memberId;
    this.itemInfo.displayId = this.item.displayId;
    this.itemInfo.productId = this.item.productId;
    this.itemInfo.installmentsNumber = this.item.installmentsNumber;
    this.itemInfo.creditPriceMonth = this.item.creditPriceMonth;
    this.itemInfo.totalPrice = this.item.totalPrice;
    console.log(`this.item === ${JSON.stringify(this.item)}`)
    console.log(`this.itemInfo === ${JSON.stringify(this.itemInfo)}`)
  },
  methods: {
    ...mapActions(['uploadImageData']),
    changeRoute() {
      this.$refs.file.value = null;
    },
    removeImage(caseId) {
      const copy = JSON.parse(JSON.stringify(this.uploadedFiles));
      copy.forEach((item, index) => {
        if (item.caseId === caseId) {
          this.uploadedFiles.splice(index, 1);
        }
      });
      if (this.uploadedFiles.length === 0) {
        this.$refs.file.value = null;
      }
    },
    closeDialogView(){
      this.imageEditor.visible = false;
      this.isDropboxVisible = true;
      this.isVisible = false;
    },
    async save() {
      if(this.itemInfo.carId === '') {
        this.$emit('onErrorMessage','請輸入大牌號碼');
        return;
      }
      if(this.itemInfo.realPrice === '' || this.itemInfo.realPrice <= 0) {
        this.$emit('onErrorMessage','請輸入實撥金額');
        return;
      }
      // if(this.uploadedFiles.length < 2 ) {
      //   this.$emit('onErrorMessage','請輸入上傳優撥相關文件');
      //   return;
      // }
      if (this.uploadedFiles.length > 0)
      {
        await this.uploadPDF();
      }

      this.$emit('onFinishUpload', this.itemInfo);
    },
    async uploadPDF(){
      let fileArray = this.uploadedFiles.filter(m=>m.code === '1');
      if ( fileArray.length > 0) {
        const file1 = fileArray[0]
        const file1Name = `${this.item.displayId} ${this.item.name}.pdf`;
        const uploadResult1 = await this.uploadImageData({
              name: file1Name,
              image: file1.data,
            });
        console.log(`uploadResult1 file1 == ${uploadResult1}`);
        this.itemInfo.fileURL1 = uploadResult1;
        this.itemInfo.fileName1 = file1.name;
      }

      fileArray = this.uploadedFiles.filter(m=>m.code === '2');
      if ( fileArray.length > 0) {
        const file2 = fileArray[0]
        const file2Name = `${this.item.name} ${this.itemInfo.carId}.pdf`;
        const uploadResult2 = await this.uploadImageData({
              name: file2Name,
              image: file2.data,
            });
        console.log(`uploadResult2 file1 == ${uploadResult2}`);
        this.itemInfo.fileURL2 = uploadResult2;
        this.itemInfo.fileName2 = file2.name;
      }
    },
    filesChange(fieldName, fileList) {
      const files = Object.values(this.$refs.file.files);
      if (!fileList.length) return;

      if (!this.busType) {
        this.$refs.file.value = null;
        this.$emit('onErrorMessage','請選擇貸款文件相關圖檔');
        return;
      }
      if (fileList.length > 1) {
        this.$refs.file.value = null;
        this.$emit('onErrorMessage','只能上傳一張圖');
        return;
      }

      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map((i, x) => {
          const file = {
            name: fileList[x].name,
            image: fileList[x],
            size: fileList[x].size,
            type: fileList[x].type,
          };

          this.createImage(i, file, fileList.length - 1);
        });
    },
    createImage(i, file, total) {
      const reader = new FileReader();
      const fileName = this.getFileName();
      const fileType = this.getFileType(file.type);
      const code = this.busType;

      reader.onload = (e) => {
        const data = e.target.result;

          let userCaseItem = new UseCaseModel();
            userCaseItem.caseId = Math.uuidFast();

            userCaseItem.code = code;
            // base64 image
            userCaseItem.data = data;
            // 檔案類型
            userCaseItem.type = fileType;
            // 檔案大小
            userCaseItem.size = data.length;
            // 檔案名稱
            userCaseItem.name = fileName;
          this.uploadedFiles.push(userCaseItem);

      };
      reader.readAsDataURL(file.image);
    },
    getFileName() {
      const itemArray = this.caseTypeList.filter((m) => m.key === this.busType);
      if (itemArray.length > 0) {
        const item = itemArray[0];
        return item.text;
      } else {
        return "";
      }
    },
    getFileType(type) {
      const name = type.toLowerCase();
      if (name.indexOf('jpeg') > -1 || name.indexOf('jpg') > -1) {
        return 'jpg';
      }
      if (name.indexOf('png') > -1) {
        return 'png';
      }
      if (name.indexOf('pdf') > -1) {
        return 'pdf';
      }
      return 'zip';
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
  },
};
</script>

<style scoped>
.pdf-container{
    width: 100%;
    height: 100%;
    position: absolute;
    top:0;
    left:0;
    bottom:0;
    right:0;
  }

.imgBox {
  box-shadow: 4px 4px 12px -2px rgba(20%, 20%, 40%, 0.5);
}

.image-view {
  width: 100%;
  height: 180px;
  object-fit: scale-down;
}

.image-title {
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  display: block;
  overflow: hidden;
}

.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: white;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: white;
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
.selectedIamge {
  border-radius: 50%;
  background-color: #44ad53;
  height: 30px;
  width: 30px;
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/PriorityCreditView.vue